import { StateObject } from '../types/common';

const bankMetadataSelector = (state: StateObject) => state.common.bankMetadata;

const brandSelector = (state: StateObject) => state.common.brand;

const CCHandoffIdSelector = (state: StateObject) =>
  state.common.session?.cc_handoff_id;

const CCHandoffUrlSelector = (state: StateObject) =>
  state.common.session?.cc_handoff_url;

const commonDocsSelector = (state: StateObject) =>
  state.common.session?.common_docs;

const creditBureauSelector = (state: StateObject) =>
  state.common.session?.bureau;

const customerInfoSelector = (state: StateObject) => state.common.customerInfo;

const customerNamesSelector = (state: StateObject) => ({
  firstName: state.common.session?.applicant_name,
  lastName: state.common.session?.applicant_last_name,
});

const documentSelector = (state: StateObject) => state.common.document;

const currDocRefSelector = (state: StateObject) => state.common.documentRef;

const firstPaymentDateSelector = (state: StateObject) =>
  state.common.session?.['first-payment-date'];

const isMultipleOfferFlowSelector = (state: StateObject) =>
  state.common.isMultipleOfferFlow;

const isOfferExpiredSelector = (state: StateObject) =>
  state.common.isOfferExpired;

const isProcessingSelector = (state: StateObject) => state.common.isProcessing;

const last4Selector = (state: StateObject) => state.common.last4;

const lazyDocsInFlightSelector = (state: StateObject) =>
  state.common.lazyDocsInFlight;

const lazyDocsSelector = (state: StateObject) => state.common.lazyDocs;

const loanOfferSelectionSelector = (state: StateObject) =>
  state.common.loanOfferSelection;

const loanOffersSelector = (state: StateObject) =>
  state.common.session?.product_offers?.offers ||
  state.common.session?.loan_offers ||
  [];

const localeSelector = (state: StateObject) => state.common.locale;

const mcodeSelector = (state: StateObject) => state.common.mcode;

const nextSelector = (state: StateObject) => state.common.next;

const optionsSelector = (state: StateObject) => state.common.options;

const campaignsSelector = (state: StateObject) => state.common.campaigns;

const subventionPromo = (state: StateObject) =>
  state.common.subventionPromo || false;

const orderIdSelector = (state: StateObject) => state.common.session?.order_id;

const orderLoadStatusSelector = (state: StateObject) =>
  state.common.orderLoadStatus;

const originalAddressSelector = (state: StateObject) =>
  state.common.session?.original_address;

const pageSelector = (state: StateObject) => state.common.page;

const previousPageSelector = (state: StateObject) => state.common.previousPage;

const paymentMethodSelector = (state: StateObject) =>
  state.common.paymentMethod;

const paymentOptionsSelector = (state: StateObject) =>
  state.common.paymentOptions;

const plaidDisabledSelector = (state: StateObject) =>
  state.common.plaidDisabled;

const plaidLinkTokenSelector = (state: StateObject) =>
  state.common.plaidLinkToken;

const pollCallCountSelector = (state: StateObject) =>
  state.common.pollCallCount;

const reservationsSelector = (state: StateObject) => ({
  airReservations: state.common.airReservations,
  hotelReservations: state.common.hotelReservations,
  cruiseReservations: state.common.cruiseReservations,
});

const sessionAutoPaySelector = (state: StateObject) =>
  state.common.session?.['rege_opt-in'];

const showBannerSelector = (state: StateObject) => state.common.showBanner;

const tooltipContainerRefSelector = (state: StateObject) =>
  state.common.tooltipContainerRef;

const upcodeSelector = (state: StateObject) => state.common.upcode;

const isOnboardSpendSelector = (state: StateObject) =>
  state.common.isOnboardSpend;

export {
  bankMetadataSelector,
  brandSelector,
  CCHandoffIdSelector,
  CCHandoffUrlSelector,
  commonDocsSelector,
  creditBureauSelector,
  customerInfoSelector,
  customerNamesSelector,
  documentSelector,
  currDocRefSelector,
  firstPaymentDateSelector,
  isMultipleOfferFlowSelector,
  isOfferExpiredSelector,
  isProcessingSelector,
  last4Selector,
  lazyDocsInFlightSelector,
  lazyDocsSelector,
  loanOfferSelectionSelector,
  loanOffersSelector,
  localeSelector,
  mcodeSelector,
  nextSelector,
  optionsSelector,
  orderIdSelector,
  orderLoadStatusSelector,
  originalAddressSelector,
  pageSelector,
  previousPageSelector,
  paymentMethodSelector,
  paymentOptionsSelector,
  plaidDisabledSelector,
  plaidLinkTokenSelector,
  pollCallCountSelector,
  reservationsSelector,
  sessionAutoPaySelector,
  showBannerSelector,
  tooltipContainerRefSelector,
  upcodeSelector,
  isOnboardSpendSelector,
  campaignsSelector,
  subventionPromo,
};
